(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swng-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    // Desplegar el resto de los reviews
    var more = event.target.closest('[data-swng-cr-more]');
    if (more) {
      var moreRoot = more.closest('.swng-cr');
      if (!moreRoot) return;
      moreRoot.querySelectorAll('[data-swng-cr-hidden]').forEach(function (item) {
        item.hidden = false;
        item.removeAttribute('data-swng-cr-hidden');
      });
      if (more.parentElement) more.parentElement.hidden = true;
      return;
    }

    // Abrir el popup de fotos
    var opener = event.target.closest('[data-cr-open]');
    if (opener) {
      var openRoot = opener.closest('.swng-cr');
      if (!openRoot) return;
      var modal = openRoot.querySelector('[data-cr-modal]');
      if (!modal || typeof modal.showModal !== 'function') return;

      modal.showModal();

      var targetId = opener.getAttribute('data-cr-target');
      var body = modal.querySelector('.swng-cr__modal-body');
      if (body) body.scrollTop = 0;
      if (targetId) {
        var target = modal.querySelector('#' + targetId);
        if (target && body) body.scrollTop = target.offsetTop - body.offsetTop;
      }
      return;
    }

    // Cerrar con la X
    var closer = event.target.closest('[data-cr-close]');
    if (closer) {
      var dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    // Cerrar tocando fuera del contenido
    if (event.target.tagName === 'DIALOG' && event.target.hasAttribute('data-cr-modal')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swng-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  /* Galería sticky en desktop: si la galería es más alta que la pantalla (notebooks de 768px), el top se corre hacia
     arriba lo justo para que las miniaturas queden siempre a la vista. */
  (function(){
    var g=document.querySelector('.swng-pdp-hero__gallery'); if(!g) return;
    var mq=window.matchMedia('(min-width:750px)');
    function fit(){ if(!mq.matches){ g.style.top=''; return; } g.style.top=Math.min(110, window.innerHeight-g.offsetHeight-16)+'px'; }
    fit(); window.addEventListener('resize',fit,{passive:true}); window.addEventListener('load',fit);
    if('ResizeObserver' in window) new ResizeObserver(fit).observe(g);
  })();
  document.querySelectorAll('.swng-pdp-hero').forEach(function(root){
    if(root.dataset.swngBound) return; root.dataset.swngBound='1';
    var main=root.querySelector('[data-swng-gallery]'); var thumbs=root.querySelectorAll('[data-swng-thumb]');
    if(!main||!thumbs.length) return;
    var slides=[].slice.call(main.children); var strip=root.querySelector('[data-swng-thumbs]');
    function pos(i){ return slides[i].offsetLeft - slides[0].offsetLeft; }
    function cur(){ var sl=main.scrollLeft, best=0, bd=1e9; slides.forEach(function(s,i){ var d=Math.abs(pos(i)-sl); if(d<bd){ bd=d; best=i; } }); return best; }
    function setOn(i){ thumbs.forEach(function(t){ t.classList.toggle('is-on', t.dataset.swngThumb==String(i)); }); var t=thumbs[i]; if(t&&strip){ var left=(t.offsetLeft-thumbs[0].offsetLeft)-(strip.clientWidth-t.clientWidth)/2; strip.scrollTo({left:left,behavior:'smooth'}); } }
    // `current` es el destino, no lo que dice scrollLeft a mitad del smooth scroll: asi dos clicks seguidos en la flecha avanzan dos imagenes.
    var current=0, lock=0;
    function go(i){ i=Math.max(0,Math.min(slides.length-1,i)); current=i; lock=Date.now()+700; main.scrollTo({left:pos(i),behavior:'smooth'}); setOn(i); }
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ go(parseInt(t.dataset.swngThumb,10)); }); });
    var prev=root.querySelector('[data-swng-prev]'), next=root.querySelector('[data-swng-next]');
    if(prev) prev.addEventListener('click',function(){ go(current-1); });
    if(next) next.addEventListener('click',function(){ go(current+1); });
    var tick=null; main.addEventListener('scroll',function(){ if(tick) return; tick=requestAnimationFrame(function(){ tick=null; if(Date.now()>lock){ current=cur(); setOn(current); } }); });
  });

  (function(){
    var vids=[].slice.call(document.querySelectorAll('.swng-pdp-hero video:not([data-swng-cv-video]):not([data-swng-vrm-video])'));
    if(vids.length){
      /* Autoplay robusto (2026-09-21). Antes: play() una sola vez al entrar en pantalla y un
         visibilitychange que llamaba a tryPlay() sin definir (ReferenceError al volver a la
         pestana). En Low Power Mode (iOS), ahorro de datos o navegadores in-app, play() se
         rechaza y el video quedaba negro para siempre. Ahora: reintento con el primer gesto
         del usuario, al volver a la pestana (visibilitychange/pageshow) y cuando llegan datos. */
      var vis=('WeakMap' in window)?new WeakMap():null;
      function ratio(v){ return vis?(vis.get(v)||0):1; }
      vids.forEach(function(v){ v.muted=true; v.defaultMuted=true; v.loop=true; v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline',''); });
      function load(v){ if(!v.dataset.src||v.dataset.loaded) return; v.dataset.loaded='1'; v.src=v.dataset.src; v.preload='metadata'; v.load(); }
      function tryPlay(v){ load(v); v.muted=true; var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
      var raf=0;
      function playVisible(){ if(raf) return; raf=requestAnimationFrame(function(){ raf=0; vids.forEach(function(v){ if(v.paused&&ratio(v)>=0.35) tryPlay(v); }); }); }
      if('IntersectionObserver' in window){
        // descarga anticipada: 400px antes de entrar en pantalla
        var pre=new IntersectionObserver(function(e){ e.forEach(function(en){ if(en.isIntersecting){ load(en.target); pre.unobserve(en.target); } }); },{rootMargin:'400px'});
        var io=new IntersectionObserver(function(entries){ entries.forEach(function(en){ var v=en.target; if(vis) vis.set(v,en.intersectionRatio); if(en.intersectionRatio>=0.35){ tryPlay(v); } else if(!v.paused){ v.pause(); } }); },{threshold:[0,0.35,1]});
        vids.forEach(function(v){ pre.observe(v); io.observe(v); });
      } else { vids.forEach(function(v){ tryPlay(v); }); }
      ['touchend','pointerup','click','keydown','scroll'].forEach(function(ev){ window.addEventListener(ev,playVisible,{passive:true}); });
      document.addEventListener('visibilitychange',function(){ if(!document.hidden) playVisible(); });
      window.addEventListener('pageshow',playVisible);
      vids.forEach(function(v){ v.addEventListener('loadeddata',playVisible); });
    }
    /* Video del coach: mudo en loop mientras se ve; al tocarlo arranca desde 0 con sonido (sin popup).
       Con sonido: tocar pausa/reanuda, el botón de arriba vuelve a mutear, al salir de pantalla se pausa
       y al terminar vuelve al loop mudo. */
    document.querySelectorAll('.swng-pdp-hero [data-swng-cv]').forEach(function(fr){
      var v=fr.querySelector('video'), fill=fr.querySelector('.swng-pdp-hero__cv-fill'), seen=false;
      function load(){ if(v.dataset.src&&!v.dataset.loaded){ v.dataset.loaded='1'; v.src=v.dataset.src; v.preload='metadata'; v.load(); } }
      function play(){ load(); var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
      function toMutedLoop(){ v.muted=true; v.loop=true; fr.classList.remove('is-sound','is-paused'); if(seen) play(); }
      function withSound(){ v.muted=false; v.loop=false; v.currentTime=0; fr.classList.add('is-sound'); fr.classList.remove('is-paused'); play(); }
      fr.addEventListener('click',function(e){
        if(e.target.closest('[data-swng-cv-mute]')){ e.stopPropagation(); toMutedLoop(); return; }
        if(!fr.classList.contains('is-sound')){ withSound(); return; }
        if(v.paused){ play(); } else { v.pause(); }
      });
      v.addEventListener('play',function(){ fr.classList.remove('is-paused'); });
      v.addEventListener('pause',function(){ fr.classList.add('is-paused'); });
      v.addEventListener('ended',toMutedLoop);
      v.addEventListener('timeupdate',function(){ if(fill&&v.duration) fill.style.width=(v.currentTime/v.duration*100)+'%'; });
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(en){ if(en[0].isIntersecting) load(); },{rootMargin:'400px'}).observe(fr);
        new IntersectionObserver(function(en){ var r=en[0].intersectionRatio; seen=r>=0.35;
          if(seen){ if(v.muted) play(); } else if(!v.paused){ v.pause(); } },{threshold:[0,0.35,1]}).observe(fr);
      } else { seen=true; play(); }
      ['touchend','scroll'].forEach(function(ev){ window.addEventListener(ev,function(){ if(seen&&v.muted&&v.paused) play(); },{passive:true}); });
    });
    document.querySelectorAll('.swng-pdp-hero [data-swng-vr]').forEach(function(row){
      var fill=row.parentElement.querySelector('.swng-pdp-hero__vr-fill'); if(!fill) return;
      function upd(){ var max=row.scrollWidth-row.clientWidth; var vis=row.clientWidth/row.scrollWidth; var pos=max>0? row.scrollLeft/max : 0; fill.style.width=(vis*100)+'%'; fill.style.marginLeft=(pos*(100-vis*100))+'%'; }
      row.addEventListener('scroll',upd,{passive:true}); upd();
    });
  })();

  (function(){
    var m=document.querySelector('[data-swng-vrm]'); if(!m||m.dataset.swngBound) return; m.dataset.swngBound='1';
    if(m.parentElement!==document.body) document.body.appendChild(m);
    var mv=m.querySelector('[data-swng-vrm-video]'); var pausedByModal=[];
    function open(src){ pausedByModal=[]; document.querySelectorAll('.swng-pdp-hero video, .swng-pdp-video video').forEach(function(v){ if(!v.paused){ v.pause(); pausedByModal.push(v); } });
      mv.src=src; mv.muted=false; m.classList.add('is-open'); document.body.style.overflow='hidden';
      void m.offsetHeight; setTimeout(function(){ m.classList.add('is-in'); },20);
      mv.play().catch(function(){});
    }
    function close(){ m.classList.remove('is-in'); mv.pause();
      setTimeout(function(){ m.classList.remove('is-open'); mv.removeAttribute('src'); mv.load(); document.body.style.overflow=''; pausedByModal.forEach(function(v){ v.play().catch(function(){}); }); },320); }
    document.querySelectorAll('.swng-pdp-hero__vr-item').forEach(function(it){ var v=it.querySelector('video'); if(!v) return; it.addEventListener('click',function(){ open(v.dataset.full||v.currentSrc||v.src||v.dataset.src); }); });
    m.querySelectorAll('[data-swng-vrm-close]').forEach(function(b){ b.addEventListener('click',close); });
    var go=m.querySelector('[data-swng-vrm-goto]');
    if(go){ go.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); close();
      setTimeout(function(){ var t=document.querySelector('.swng-pdp-hero__form [class*="kaching"], .swng-pdp-hero__app, .swng-pdp-hero__form'); if(!t) return; var top=t.getBoundingClientRect().top+window.scrollY-100; window.scrollTo({top:top,behavior:'smooth'}); },340); }); }
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&m.classList.contains('is-open')) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swng-pdp-radial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var els=document.querySelectorAll('.swng-pdp-radial [data-swng-count]');
    if(!els.length) return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function finish(el){ el.textContent=el.dataset.swngCount+(el.dataset.swngSuffix||''); }
    if(reduce||!('IntersectionObserver' in window)){ els.forEach(finish); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return; var el=en.target; io.unobserve(el);
        if(el.dataset.swngDone) return; el.dataset.swngDone='1';
        var target=parseInt(el.dataset.swngCount,10)||0, suf=el.dataset.swngSuffix||'', dur=1400, t0=null;
        function step(ts){ if(!t0) t0=ts; var p=Math.min((ts-t0)/dur,1); var e=1-Math.pow(1-p,3); el.textContent=Math.round(target*e)+suf; if(p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    },{threshold:.5});
    els.forEach(function(e){io.observe(e);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swng-pdp-sticky"] && !Shopify.designMode) return;
  try {
    
  // El CTA de la barra NO agrega al carrito: lleva al selector de bundles.
  document.querySelectorAll('[data-swng-sticky-goto]').forEach(function(b){
    if(b.dataset.swngBound) return; b.dataset.swngBound='1';
    b.addEventListener('click',function(e){
      e.preventDefault();
      var t=document.querySelector('.swng-pdp-hero__app, .kaching-bundles, .swng-pdp-hero__form');
      if(!t) return;
      window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-100, behavior:'smooth'});
    });
  });
  document.querySelectorAll('[data-swng-sticky]').forEach(function(bar){
    if(bar.dataset.swngBound) return; bar.dataset.swngBound='1';
    var form=document.getElementById('swng-pdp-form'); if(!form){ bar.classList.add('is-visible'); return; }
    var btn=form.querySelector('button[type=submit]')||form;
    if(!('IntersectionObserver' in window)){ bar.classList.add('is-visible'); return; }
    var io=new IntersectionObserver(function(en){ bar.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top<0); },{threshold:0});
    io.observe(btn);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swng-pdp-video"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.swng-pdp-video [data-swng-play]').forEach(function(btn){
      if(btn.dataset.swngBound) return; btn.dataset.swngBound='1';
      btn.addEventListener('click',function(){ var wrap=btn.closest('[data-swng-video]'); var f=document.createElement('iframe'); f.src=btn.dataset.src; f.allow='autoplay; fullscreen'; f.setAttribute('allowfullscreen',''); f.title='Video'; wrap.appendChild(f); btn.remove(); });
    });
    var vids=[].slice.call(document.querySelectorAll('.swng-pdp-video video[data-swng-autoplay], .swng-pdp-video video.swng-pdp-video__vid'));
    if(vids.length){
      /* Autoplay robusto (2026-09-21). Antes: play() una sola vez al entrar en pantalla y un
         visibilitychange que llamaba a tryPlay() sin definir (ReferenceError al volver a la
         pestana). En Low Power Mode (iOS), ahorro de datos o navegadores in-app, play() se
         rechaza y el video quedaba negro para siempre. Ahora: reintento con el primer gesto
         del usuario, al volver a la pestana (visibilitychange/pageshow) y cuando llegan datos. */
      var vis=('WeakMap' in window)?new WeakMap():null;
      function ratio(v){ return vis?(vis.get(v)||0):1; }
      vids.forEach(function(v){ v.muted=true; v.defaultMuted=true; v.loop=true; v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline',''); });
      function load(v){ if(!v.dataset.src||v.dataset.loaded) return; v.dataset.loaded='1'; v.src=v.dataset.src; v.preload='metadata'; v.load(); }
      function tryPlay(v){ load(v); v.muted=true; var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
      var raf=0;
      function playVisible(){ if(raf) return; raf=requestAnimationFrame(function(){ raf=0; vids.forEach(function(v){ if(v.paused&&ratio(v)>=0.35) tryPlay(v); }); }); }
      if('IntersectionObserver' in window){
        // descarga anticipada: 400px antes de entrar en pantalla
        var pre=new IntersectionObserver(function(e){ e.forEach(function(en){ if(en.isIntersecting){ load(en.target); pre.unobserve(en.target); } }); },{rootMargin:'400px'});
        var io=new IntersectionObserver(function(entries){ entries.forEach(function(en){ var v=en.target; if(vis) vis.set(v,en.intersectionRatio); if(en.intersectionRatio>=0.35){ tryPlay(v); } else if(!v.paused){ v.pause(); } }); },{threshold:[0,0.35,1]});
        vids.forEach(function(v){ pre.observe(v); io.observe(v); });
      } else { vids.forEach(function(v){ tryPlay(v); }); }
      ['touchend','pointerup','click','keydown','scroll'].forEach(function(ev){ window.addEventListener(ev,playVisible,{passive:true}); });
      document.addEventListener('visibilitychange',function(){ if(!document.hidden) playVisible(); });
      window.addEventListener('pageshow',playVisible);
      vids.forEach(function(v){ v.addEventListener('loadeddata',playVisible); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swng-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nums = document.querySelectorAll('[data-swng-count]');
    if (!nums.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animate(el) {
      var target = parseInt(el.dataset.swngCount, 10) || 0;
      if (reduce) { el.textContent = target + '%'; return; }
      var t0 = null, dur = 1400;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + '%';
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !e.target.dataset.swngDone) {
          e.target.dataset.swngDone = '1';
          animate(e.target);
        }
      });
    }, { threshold: .4 });
    nums.forEach(function (n) { io.observe(n); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swng-system"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-swng-tabs]').forEach(function (scope) {
    if (scope.dataset.swngBound) return;
    scope.dataset.swngBound = '1';
    var tabs = scope.querySelectorAll('[data-swng-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          scope.querySelectorAll('[data-swng-panel="' + t.dataset.swngTab + '"]').forEach(function (p) {
            p.hidden = !on;
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swng-ugc"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.swng-ugc__rail').forEach(function (rail) {
    if (rail.dataset.swngBound) return;
    rail.dataset.swngBound = '1';
    var track = rail.querySelector('.swng-ugc__track');
    if (!track) return;
    var t;
    ['pointerdown', 'touchstart'].forEach(function (ev) {
      rail.addEventListener(ev, function () {
        track.style.animationPlayState = 'paused';
        clearTimeout(t);
        t = setTimeout(function () { track.style.animationPlayState = 'running'; }, 4000);
      }, { passive: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swng-work"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-swng-tabs]').forEach(function (scope) {
    if (scope.dataset.swngBound) return;
    scope.dataset.swngBound = '1';
    var tabs = scope.querySelectorAll('[data-swng-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          scope.querySelectorAll('[data-swng-panel="' + t.dataset.swngTab + '"]').forEach(function (p) {
            p.hidden = !on;
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
